export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#0A1628] via-[#1A2B4A] to-[#0A1628]"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      
      <div className="absolute inset-0 opacity-30">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#00D9FF] rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`,
            }}
          />
        ))}
      </div>

      <div className="relative w-full px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center max-w-[1400px] mx-auto">
          <div className="lg:col-span-3 space-y-8">
            <div className="inline-block">
              <span className="inline-flex items-center px-6 py-3 bg-[#00D9FF]/20 text-[#00D9FF] text-xs font-semibold rounded-full border border-[#00D9FF]/30 whitespace-nowrap">
                iOS Development Experts
              </span>
            </div>

            <h2 className="text-6xl lg:text-7xl font-bold text-white leading-tight">
              Modern Applications
              <br />
              <span className="text-[#00D9FF]">For iOS Platform</span>
              <br />
              Built With Precision
            </h2>

            <p className="text-xl text-[#B8C5D6] max-w-[520px] leading-relaxed">
              TAFARUCI SH.P.K. is a team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="lg:col-span-2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[400px]">
              <div className="absolute inset-0 bg-gradient-to-br from-[#00D9FF]/30 to-[#0066FF]/30 rounded-[40px] blur-3xl"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/4313febf3e26513176979c9e51def837.jpg"
                alt="iOS Application Showcase"
                className="relative w-full h-auto object-contain transform rotate-6 hover:rotate-3 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}